// @flow

// EU "EmpCo" directive (#56424): documents and links of the harmonised notice on the legal guarantee
// of conformity and of the EU GARAN label for the manufacturer guarantee.

// "Your Europe" portal per language as listed in the EU practical guidelines - the destination of the
// QR code printed on the notice. Only the languages the module ships a notice for are listed.
const NOTICE_PORTAL_PATHS = {
    cs: "záruky_cs",
    da: "garantier",
    de: "garantien",
    el: "εγγυήσεις",
    en: "guarantees",
    es: "garantías",
    fr: "garanties",
    hu: "jótállás",
    it: "garanzie",
    nl: "garantie",
    pl: "gwarancje",
    pt: "garantias",
    sv: "reklamationsrätt",
};

export const NOTICE_LANGUAGES: string[] = Object.keys(NOTICE_PORTAL_PATHS);
export const FALLBACK_LANGUAGE = "en";

// Destination of the QR code on the GARAN label (language selection happens on the portal).
export const LABEL_PORTAL_URL = "https://europa.eu/youreurope/commercial-guarantee-durability/index.htm";

export const resolveNoticeLanguage = (language: ?string): string => {
    const code = (language || "").slice(0, 2).toLowerCase();
    return NOTICE_LANGUAGES.includes(code) ? code : FALLBACK_LANGUAGE;
};

export const noticePortalUrlFor = (language: ?string): string =>
    encodeURI(`https://europa.eu/youreurope/${NOTICE_PORTAL_PATHS[resolveNoticeLanguage(language)]}`);

// The notice SVGs are ~0.5 MB each: webpack splits them into one chunk per language and the browser
// fetches only the one that is actually opened.
export const loadNoticeDocument = (language: ?string): Promise<string> =>
    import(`../../assets/empco/notice/notice_${resolveNoticeLanguage(language)}.svg`)
        .then(module => module.default);
